// Receipt/ticket generation, ported from exportSelectedToJSON.gs.
// Produces the same "ticket" JSON the legacy thermal-printer workflow consumes,
// one ticket per line item, and downloads it as thermal_batch_<ts>.json.

import { REPEAT_VERDICT } from '../constants';

const fmtDate = (d) =>
  d instanceof Date && !Number.isNaN(d.getTime())
    ? d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' })
    : '';

// Reconstruct the legacy "BESPOKE / LEATHER" flag string from structured fields.
function bespokeFlag(order, lineItem) {
  const flags = [];
  const r = order.repeatCustomer;
  const past =
    r && (r.verdict === REPEAT_VERDICT.YES || (r.verdict === REPEAT_VERDICT.MAYBE && r.confirmedByUser === true));
  if (past) flags.push('PAST CUSTOMER');
  if (lineItem.isLeather || order.workflow?.isLeather) flags.push('LEATHER');
  if (order.workflow?.ftoc) flags.push('FTOC');
  return flags.join(' / ');
}

/** Build the ticket array (one per line item) for the given orders. */
export function buildTickets(orders) {
  const tickets = [];
  orders.forEach((order) => {
    (order.lineItems || []).forEach((li) => {
      tickets.push({
        channel: order.legacyChannel,
        id: order.platformOrderId,
        userId: order.buyer?.userId || '',
        buyer: order.buyer?.name || '',
        product: li.product || '',
        variation: li.variation || '',
        notes: li.buyerNotes || '',
        bespoke: bespokeFlag(order, li),
        postBy: fmtDate(order.dates?.postByEffective),
        postage2: order.shipping?.service || '',
      });
    });
  });
  return tickets;
}

/** Download the tickets JSON (thermal_batch_<ts>.json). Returns the count. */
export function downloadReceipts(orders) {
  const tickets = buildTickets(orders);
  const json = JSON.stringify(tickets, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `thermal_batch_${Date.now()}.json`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return tickets.length;
}
